export const frontmatter = {
    "draft": false,
    "title": "Administración",
    "description": "Administración de la plataforma OnnIA: organizaciones, equipos, planes y configuración del sistema.",
    "sidebar_label": "Descripción general",
    "sidebar_group": "referencia",
    "sidebar_order": 0
}

export const toc = []